import React, { memo } from 'react';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import { Icon, RouterLink, Section } from 'src/components';
import TitleWrap from 'src/modules/shared/components/TitleWrap';
import { useTracking } from 'src/hooks/useTracking';
import { ContentList } from 'src/modules/content/components/list';
import { SECTION_ID } from 'src/constants';

interface IProps extends IBaseSection<IContent> {
    ContentItemComponent?: React.FunctionComponent<any>;
}

export function ContentTopicType2Section(props: IProps) {
    const {
        items = [],
        title = '',
        link = '',
        id,
        className = cn(
            'topic2-section',
            'relative',
            'border-y-[6px] border-solid border-[#F5F6F7]',
            'mt-[24px] mb-[20px] p-[4px_20px_4px]',
            'ml-[-20px]',
            'w-[calc(100%+40px)]',
        ),
        displayTimeIn,
        position,
        tracking = `|type_02|${position}|${id}`,
    } = props;

    const trackingRef = useTracking(id, `imps_type_02|${position}`, {
        threshold: 0.5,
    });

    if (!items.length) {
        return null;
    }

    return (
        <Section className={className} domRef={trackingRef}>
            <TitleWrap
                title={title?.indexOf('#') > -1 ? title.slice(1) : title}
                link={link}
                renderAs="h2"
                data-text={`${title}`}
                className={cn(
                    'relative',
                    'text-[20px]',
                    'h-[44px]',
                    'leading-[44px]',
                    'font-[900]',
                    'uppercase',
                    'text-[#286C80]',
                    'mb-[4px]',
                )}
                classNameLink={cn(
                    "before:content-['#']",
                    'before:inline-block',
                )}
            />
            <ContentList
                sectionId={`${SECTION_ID.CONTENT_BY_TOPIC}`}
                items={items.slice(0,4)}
                tracking={tracking}
                displayTimeIn={displayTimeIn}
                hasLayoutPhoto={false}
                className={cn('flex flex-wrap gap-x-[12px] gap-y-[24px]')}
                ContentItemProps={{ lazyloadImage: false }}
                ContentItemClass={{
                    CardClass: cn(
                        '!block !w-[calc(50%-6px)]',
                        '!border-none',
                        '!mt-0 !pt-0',
                    ),
                    CardImageClass: '!w-full !pb-[66.88%] my-0',
                    CardContentClass: '!ml-0 !pt-[12px]',
                }}
            />
            <RouterLink
                to={link}
                className={cn(
                    'uppercase text-[14px] leading-[1] font-semibold',
                    'h-[36px]',
                    'flex items-center justify-center',
                    'mt-[16px]',
                )}
            >
                <Icon
                    icon="new-video-expand-regular"
                    className="text-[16px] mr-[8px]"
                />
                <span>Xem thêm</span>
            </RouterLink>
        </Section>
    );
}

export default memo(ContentTopicType2Section);
